<script setup>

</script>

<template>
  <svg width="77" height="100" viewBox="0 0 77 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.692383 25.5385L25.1539 50L0.692383 74.4615L26.2308 100L76.2308 50L26.2308 0L0.692383 25.5385Z" fill="#376FFE"/>
  </svg>
</template>

<style scoped lang="scss">

</style>
